import React, { useState } from "react";
import { getCookie } from "../../utils/cookies";
import axios from "axios";
import { Button } from "react-bootstrap";
import { SendCheck } from "react-bootstrap-icons";
import { Modal } from "react-bootstrap";
import AlertDialog from "../../ui/alerts/AlertDialog";
import { BACKGROUND_CHECK_STATUS } from "../../constants/ BACKGROUND_CHECK_STATUS";
export default function SendBackgroundCheck({ data, handleSuccess }) {
  // Form Modal state
  const [showSendBackgroundCheck, setShowSendBackgroundCheck] = useState(false);

  // Show and Hide Form Modal
  const handleClose = () => setShowSendBackgroundCheck(false);
  const handleShow = () => setShowSendBackgroundCheck(true);

  const [isLoading, setIsLoading] = useState(true);

  // Success Dialog State
  const [showSuccess, setShowSuccess] = useState(false);

  // Error Dialog State
  const [showError, setShowError] = useState(false);

  // UPDATE
  const updateBackgroundCheckStatus = async (id: number) => {
    try {
      const JWT = await getCookie("ea1-auth");
      const { data: userResp } = await axios(
        `https://ea1-dev.azurewebsites.net/api/userServiceProviderDetail/${id}`,
        {
          method: "PATCH",
          data: {
            background_check_status:
              BACKGROUND_CHECK_STATUS.PENDING_PROVIDER_INPUT,
          },
          headers: {
            "Content-Type": "application/json",
            Authorization: JWT,
          },
        }
      );
      if (userResp) {
        handleSuccess(userResp);
      }
      setIsLoading(false);

      // Confirmation Modal Hide State (follow Delete method)
      setShowSendBackgroundCheck(false);

      // Success Alert Popup
      setShowSuccess(true);
    } catch (e) {
      console.log(e);
      setIsLoading(false);

      // Confirmation Modal Hide State
      setShowSendBackgroundCheck(false);

      // Error Alert Popup
      setShowError(true);
    }
  };
  const approveModal = (
    <Modal
      show={showSendBackgroundCheck}
      backdrop='static'
      onHide={handleClose}
    >
      <Modal.Header closeButton>
        <Modal.Title>Submit Background Check</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Please visit{" "}
        <a href='https://secure.us2.sterlingcheck.app/sys/' target='_blank'>
          Sterling Connect
        </a>{" "}
        and submit a background check using the email address{" "}
        <a href={`mailto:${data.email}`}>{data.email}</a> for {data.first_name}{" "}
        {data.last_name}. After sending the background check select CONFIRM
        below. <br />
        <br />
        This will set the approval status of the provider to PENDING PROVIDER
        INPUT letting use know a background check has already be sent.
      </Modal.Body>
      <Modal.Footer>
        <Button variant='outline-dark' onClick={handleClose}>
          Cancel
        </Button>
        <Button
          type='submit'
          variant='success'
          onClick={() => updateBackgroundCheckStatus(data.id)}
        >
          Confirm
        </Button>
      </Modal.Footer>
    </Modal>
  );

  const successAlert = (
    <Modal
      show={showSuccess}
      onHide={() => {
        setShowSuccess(false);
      }}
      backdrop='static'
    >
      <Modal.Header
        closeButton
        style={{ backgroundColor: "#00E676" }}
      ></Modal.Header>
      <AlertDialog
        title={"Success!"}
        message={`The providers background check status is now in Pending Provider Input. Once the service provider has submitted their background check via Sterling, set their background check status to In Review.`}
      />
    </Modal>
  );

  const errorAlert = (
    <Modal
      show={showError}
      onHide={() => {
        setShowError(false);
      }}
      backdrop='static'
      size='lg'
    >
      <Modal.Header
        closeButton
        style={{ backgroundColor: "#FF1744" }}
      ></Modal.Header>
      <AlertDialog
        title={"Error!"}
        message={"There was an error approving this Provider."}
      />
    </Modal>
  );

  return (
    <>
      <Button variant='outline-dark' onClick={handleShow}>
        <SendCheck size={25} style={{ marginRight: 5 }} />
        Send Background Check
      </Button>
      {approveModal}
      {successAlert}
      {errorAlert}
    </>
  );
}
